module.exports = __webpack_public_path__ + "img/CITI.86a801fc.png";